module.exports = __webpack_public_path__ + "img/rewards_icon.e0349871.png";